import styled from "styled-components"
const Form = styled.div`
  .form-group{
    display:block;
  }
  label{
    display:block;
  }
  input{
  display:block;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
  border-radius:20px;
  padding:12px 15px;
  background-color:#fafafa;
  border:1px solid #e3e8f0;
  width:100%;
  }
  textarea{
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
    margin-bottom: 20px;
    border-radius:20px;
    padding:12px 15px;
    background-color:#fafafa;
    border:1px solid #e3e8f0;
    width:100%;
  }
`;

export default Form